import { configureStore } from "@reduxjs/toolkit";
import corporateEventsReducer from "./corporateEventsSlice";
import chapterEventsReducer from "./chapterEventsSlice";
import eventsReducer from "./eventsSlice";
import nvkbReducer from "./nvkbSlice";
import finLitReducer from "./finLitSlice";
import siteSearchInputReducer from "./siteSearchInputSlice";
import siteSearchReducer from "./siteSearchSlice";
import savingsBenefitsReducer from "./savingsBenefitsSlice";
import chapterBlogsReducer from "./chapterBlogsSlice";
import newsReducer from "./newsSlice";
import disciplineSummariesReducer from "./disciplineSummariesSlice";
import pdSearchReducer from "./pdSearchSlice";

export const store = configureStore({
  reducer: {
    corporateEvents: corporateEventsReducer,
    chapterEvents: chapterEventsReducer,
    events: eventsReducer,
    nvkb: nvkbReducer,
    siteSearchInput: siteSearchInputReducer,
    siteSearch: siteSearchReducer,
    finLit: finLitReducer,
    savingsBenefits: savingsBenefitsReducer,
    chapterBlogs: chapterBlogsReducer,
    news: newsReducer,
    disciplineSummaries: disciplineSummariesReducer,
    pdSearch: pdSearchReducer
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
